module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "select-coupon-wrap"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("11.11大额券")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.data), function(item) {
    return (_vm.data && _vm.data.length) ? _c('div', {
      staticClass: "coupon-item",
      on: {
        "click": function($event) {
          return _vm.getCoupon(item.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("确定")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c8d2452"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/plugins/select-coupon/component/index.vue
// module id = 1066
// module chunks = 2